/* eslint-disable no-async-promise-executor */
/* eslint-disable @typescript-eslint/no-inferrable-types */

import { TabModel } from "@/model/tab/TabModel";

const indexedDB = window.indexedDB;

export const OpenTabIndexedDB = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    if (!indexedDB) throw new Error("Your browser doesn't support IndexedBD");

    const request = indexedDB.open("TabDB", 1);

    request.onerror = (e) => {
      console.error(`IndexedDB error: ${request.error}`);
      resolve(null);
    };

    request.onsuccess = (e: any) => {
      const db = e.target.result;
      resolve(db);
    };

    request.onupgradeneeded = (e: any) => {
      const db = e.target.result;
      db.createObjectStore("tab", { keyPath: "id", autoIncrement: true });
    };
  });
};

export const AddTabToIndexedDB = async (): Promise<number> => {
  const db = await OpenTabIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction(["tab"], "readwrite")
        .objectStore("tab")
        .add({ isActive: true, merchantId: 0 });

      request.onsuccess = (event: any) => {
        const tabId = event.target.result;
        db.close();
        resolve(tabId);
      };
      request.onerror = (err: any) => {
        console.error(`Error to add new Tab: ${err}`);
        db.close();
        resolve(0);
      };
    } else {
      resolve(0);
    }
  });
};

export const UpdateTabMerchantIdToIndexedDB = async (tabId: number, merchantId: number): Promise<void> => {
  const db = await OpenTabIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const objectStore = db.transaction(["tab"], "readwrite").objectStore("tab");

      const request = objectStore.get(tabId);

      request.onsuccess = () => {
        const tab = request.result;
        tab.merchantId = merchantId;
        const updateRequest = objectStore.put(tab);
        updateRequest.onsuccess = () => {
          db.close();
          resolve();
        };

        request.onerror = (err: any) => {
          console.error(`Error to update merchant id tab: ${err}`);
          db.close();
          resolve();
        };
      };
    } else {
      resolve();
    }
  });
};

export const RemoveTabFromIndexedDB = async (tabId: number): Promise<void> => {
  const db = await OpenTabIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction(["tab"], "readwrite")
        .objectStore("tab")
        .delete(tabId);
      request.onsuccess = (event: any) => {
        db.close();
        resolve();
      };
      request.onerror = (err: any) => {
        console.error(`Error to remove new tab: ${err}`);
        db.close();
        resolve();
      };
    } else {
      resolve();
    }
  });
};

export const GetAllTabsFromIndexedDB = async (): Promise<Array<TabModel>> => {
  const db = await OpenTabIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction(["tab"])
        .objectStore("tab")
        .getAll();

      request.onsuccess = () => {
        const tabs = request.result;
        db.close();
        resolve(tabs);
      };

      request.onerror = (err: any) => {
        console.error(`Error to get all tabs: ${err}`);
        db.close();
        resolve([]);
      };
    } else {
      resolve([]);
    }
  });
};
export const GetTabByIdFromIndexedDB = async (tabId: number): Promise<TabModel | null> => {
  const db = await OpenTabIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction(["tab"])
        .objectStore("tab")
        .get(tabId);

      request.onsuccess = () => {
        const tab = request.result;
        db.close();
        resolve(tab);
      };

      request.onerror = (err: any) => {
        console.error(`Error to get tab: ${err}`);
        db.close();
        resolve(null);
      };
    } else {
      resolve(null);
    }
  });
};

export const ClearTabFromIndexedDB = async (): Promise<boolean> => {
  const db = await OpenTabIndexedDB();
  return new Promise(async (resolve, reject) => {
    if (db) {
      const request = db
        .transaction(["tab"], "readwrite")
        .objectStore("tab")
        .clear();

      request.onerror = (event: any) => {
        console.error("Error deleting database.");
        db.close();
        resolve(false);
      };

      request.onblocked = (event: any) => {
        db.close();
        console.error("blocked: " + event);
        resolve(false);
      };

      request.onsuccess = (event: any) => {
        db.close();
        resolve(true);
      };
    } else {
      resolve(false);
    }
  });
};

export const CheckIndexedDBIsSupport = () => {
  return indexedDB ? true : false;
};
